<div class="mitre-grid">
  <div class="mitre-column">
    <hyperkit-badge variant="neutral" text="Tactic"></hyperkit-badge>
    @if (tactics.length > 0) {
      <hyperkit-typography
        variant="emphasized"
        size="sm"
        align="left"
        color="primary"
        >{{ tactics.join(', ') }}</hyperkit-typography
      >
    } @else {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>

  <div class="mitre-column">
    <hyperkit-badge variant="neutral" text="Technique"></hyperkit-badge>
    @if (techniques.length > 0) {
      <hyperkit-typography
        variant="emphasized"
        size="sm"
        align="left"
        color="primary"
        >{{ techniques.join(', ') }}</hyperkit-typography
      >
    } @else {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>

  <div class="mitre-column">
    <hyperkit-badge variant="neutral" text="Technique ID"></hyperkit-badge>
    @if (techniqueIds.length > 0) {
      <div class="technique-ids">
        @for (id of techniqueIds; track id; let isLast = $last) {
          <hyperkit-link
            [href]="techniqueUrl(id)"
            target="_blank"
            variant="body"
            size="sm"
            display="inline"
            align="left"
            color="secondary"
            [text]="id"
          ></hyperkit-link>
          @if (!isLast) {
            <span>,&nbsp;</span>
          }
        }
      </div>
    } @else {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>
</div>
